import React from "react";
import { SubPageBreadCrumbs } from "Components/BreadCrumbs";
import { useParams } from "react-router-dom";
import { DataTable, Menu } from "./components";
import { useSubscription } from "@apollo/client";
import { SUB_INVOICES } from "Util/subscriptions";
import { PaymentStatus } from "Util/constants";
import FinalApproval from "./FinalApproval";

const InvoiceList = (props) => {
  const params = useParams();

  const getWhere = () => {
    if (!params.type) {
      return {
        status: { _in: [PaymentStatus.AUTHORISED, PaymentStatus.DECLINED, PaymentStatus.PENDINGAUTHORISATION, PaymentStatus.APPROVED, PaymentStatus.REJECTED ] },
      }
    } else {
      if (params.type === "declined") {
        return {
          status: { _eq: PaymentStatus.DECLINED }
        }
      } else if (params.type === "pending") {
        return {
          status: { _eq: PaymentStatus.PENDINGAUTHORISATION }
        }
      } else if (params.type === "authorised") {
        return {
          status: { _eq: PaymentStatus.AUTHORISED }
        }
      } else if (params.type === "final-approval") {
        return {
          status: { _in: [PaymentStatus.AUTHORISED, PaymentStatus.APPROVED, PaymentStatus.REJECTED, PaymentStatus.FOR_FINANCE_REVISIT, PaymentStatus.PAID] }
        }
      } else {
        return {
          status: { _in: [PaymentStatus.AUTHORISED, PaymentStatus.DECLINED, PaymentStatus.PENDINGAUTHORISATION, PaymentStatus.APPROVED, PaymentStatus.REJECTED ] }
        }
      }
    }
  }

  const { data, loading, error } = useSubscription(SUB_INVOICES, {
    variables: {
      where: {
        ...getWhere(),
        // deleted_at: { _is_null: true }
      }
    },
  });

  if (params.type === "final-approval") {
    return (
      <div>
        <SubPageBreadCrumbs />
        <Menu />
        <FinalApproval data={data} loading={loading} />
      </div>
    );
  }

  const formatData = (data) => {
    if (loading) {
      return [];
    }

    if (data?.invoice) {
      return data?.invoice.map((invoice) => ({
        ...invoice,
      }));
    }

    return [];
  };

  return (
    <div>
      <SubPageBreadCrumbs />
      <Menu />
      <DataTable
        data={loading ? [] : formatData(data)}
        loading={loading}
        pageSize={50}
        height={500}
        type={params.type}
      />
    </div>
  );
};

InvoiceList.propTypes = {};

export default InvoiceList;
